import { render } from "./SystemIndex.vue?vue&type=template&id=74498fe6&scoped=true"
import script from "./SystemIndex.vue?vue&type=script&lang=js"
export * from "./SystemIndex.vue?vue&type=script&lang=js"

import "./SystemIndex.vue?vue&type=style&index=0&id=74498fe6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74498fe6"]])

export default __exports__